import script from "./DoctorAuthentication.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorAuthentication.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorAuthentication.vue?vue&type=style&index=0&id=139b8e2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139b8e2a"]])

export default __exports__